/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import {
  Card, Form, Menu, Row, Spin, Tabs, message, Modal, List, Input, Divider, Tooltip, Button, Col,
  DatePicker,
} from 'antd';
import {
  UserOutlined,
  InfoCircleOutlined,
  EnvironmentOutlined,
  FileTextOutlined,
  PhoneOutlined,
  CalendarOutlined,
  CreditCardOutlined,
  SolutionOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  CheckCircleOutlined,
  SearchOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
} from '@ant-design/icons';
import { formatReceived, formatReceivedValues } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import Table from 'components/Table';
import FormSubmitControls from 'components/FormSubmitControls';
import useSeguimientoDeRegistro from 'hooks/useSeguimientoDeRegistro';
import ModalDelete from 'components/ModalDelete';
import { checkToken } from 'api/utils';
import {
  getHonorarioAsimilado,
  postHonorarioAsimilado,
  patchHonorarioAsimilado,
  deleteHonorarioAsimilado,
  getHonorarioAsimiladoVistaoptimizado,
  putAutorizarContratacionHonorarioAsimilado,
} from 'api/catalogos/HonorarioAsimilado';
import {
  CURP_PATTERN, digitoVerificador, NOMBRES_PATTERN_GENERICO, RFC_PATTERN, SLUG_PATTERN,
} from 'utils/patterns';
import { getTiposDeDepositos } from 'api/catalogos/tiposDeDepositos';
import { getBancos } from 'api/configuraciones';
import { getMetodosDePagos } from 'api/catalogos/metodosDePagos';
import { getPaises } from 'api/catalogos/paises';
import { getMotivosDeMovimientosDeEmpleados } from 'api/catalogos/motivoDeMovimientoDeEmpleados';
import {
  getAreas,
  getEstados,
  getPeriodicidadesDePagos,
  getTiposDeEmpleados,
} from 'api/catalogos';
import { getEstadosCiviles, getGeneros } from 'api/usuarios';
import { getPuestos } from 'api/catalogos/puestos';
import { getTiemposDeContrataciones } from 'api/catalogos/tiemposDeContrataciones';
import { getJornadas } from 'api/catalogos/jornadas';
import { getTiposDeSueldos } from 'api/catalogos/tiposDeSueldos';
import { getSindicatos } from 'api/catalogos/sindicatos';
import { getZonasDeSalariosMinimos } from 'api/catalogos/zonasDeSalariosMinimos';
import { getTiposRegimenesNominas } from 'api/catalogos/tiposRegimenesNominas';
import { ESTATUS_AUTORIZADO, TIPO_MOVIMIENTO_ALTA } from 'utils/constants';
import { getTiposDeIdentificaciones } from 'api/catalogos/tiposDeIdentificaciones';
import { getTiposDeSeguridadesSociales } from 'api/catalogos/tiposDeSeguridadesSociales';
import { getTiposDeFunciones } from 'api/catalogos/tiposDeFunciones';
import { getTiposDeContrataciones } from 'api/catalogos/tiposDeContrataciones';
import { getRegistrosPatronales } from 'api/catalogos/registrosPatronales';
import { getNivelesDeEstudios } from 'api/catalogos/nivelesDeEstudios';
import { getAbreviaturasDeCarreras } from 'api/catalogos/abreviaturasDeCarreras';
import { getComprobantesDeEstudios } from 'api/catalogos/comprobantesDeEstudios';
import { getEspecialidadesDeEstudios } from 'api/catalogos/especialidadesDeEstudios';
import { getNacionalidades } from 'api/catalogos/nacionalidades';
import { getPreferenciaSPartidarias } from 'api/catalogos/PreferenciaPartidaria';
import { getEstadosDeEmpleados } from 'api/estructuraOrganizacional/estadosDeEmpleados';
import { getTiposDeNominasEmpleados } from 'api/nominas/catalogos/tiposNominasEmpleados';
import { getCaracteresDeNombramiento } from 'api/catalogos/CaracterDeNombramiento';
import { getNombramientosSinPaginar } from 'api/catalogos/Nombramientos';
import { getTiposDeOrigenesDeContratacion } from 'api/catalogos/tiposDeOrigenesDeContratacion';
import { getTiposDeActividades } from 'api/catalogos/TiposDeActividades';
import {
  getDatoOperacionalesDeHonorariosAsimilados,
  patchDatoOperacionalDelHonorarioAsimilado,
} from 'api/estructuraOrganizacional/datosOperacionalesDeHonorarioAsimilado';
import { getDatosDePagoDeHonorariosAsimilados } from 'api/estructuraOrganizacional/datosDePagoDeHonorariosAsimilados';
import currencyFormatter from 'utils/currencyFormatter';
import * as XLSX from 'xlsx';
import DocumentosHonorariosAsimilados from './HonorariosAsimilados/DocumentosHonorariosAsimilados';
import HonorarioAsimiladoFormaPago from './HonorariosAsimilados/HonorarioAsimiladoFormaPago';
import HonorarioAsimiladoDireccion from './HonorariosAsimilados/HonorarioAsimiladoDireccion';
import OtrosHonorariosAsimilados from './HonorariosAsimilados/OtrosHonorariosAsimilados';
import HonorarioAsimiladoContacto from './HonorariosAsimilados/HonorarioAsimiladoContacto';
import HonorarioAsimiladoAtributos from './HonorariosAsimilados/HonorarioAsimiladoAtributos';
import HonorarioAsimiladoAdscripcion from './HonorariosAsimilados/HonorarioAsimiladoAdscripcion';
import HonorarioAsimiladoGeneral from './HonorariosAsimilados/HonorarioAsimiladoGeneral';
import HonorarioAsimiladoFiliacion from './HonorariosAsimilados/HonorarioAsimiladoFiliacion';
import HonorarioAsimiladoEstudios from './HonorariosAsimilados/HonorarioAsimiladoEstudios';

const { TabPane } = Tabs;
const baseURI = 'estructura-organizacional/honorarios-asimilados';
const baseURIExtra = 'catalogos/dato-operacional-del-honorario-asimilado';
const baseURIExtraPago = 'catalogos/dato-de-pago-del-honorario-asimilado';

export const honorariosAsimiladosPermission = {
  permissionModel: 'honorarioasimilado',
  catalogsModels: [
    'estadodelhonorarioasimilado',
    'genero',
    'estadocivil',
    'puesto',
    'centrodecostos',
    'formadepago',
  ],
};

// Selector de columnas para exportar Excel (idéntico al de Empleados)
const ModalSelectorColumnas = ({
  visible,
  onCancel,
  onConfirm,
  columns,
  selectedColumns,
  setSelectedColumns,
}) => {
  const [searchText, setSearchText] = useState('');
  const [availableColumns, setAvailableColumns] = useState([]);
  const [orderedSelectedColumns, setOrderedSelectedColumns] = useState([]);

  useEffect(() => {
    if (columns.length > 0) {
      const available = columns.filter((col) => !selectedColumns.includes(col.key));
      setAvailableColumns(available);
    }
  }, [columns, selectedColumns]);

  useEffect(() => {
    if (selectedColumns.length === 0) {
      setOrderedSelectedColumns([]);
    } else {
      const newOrdered = [];
      orderedSelectedColumns.forEach((col) => {
        if (selectedColumns.includes(col.key)) newOrdered.push(col);
      });
      const existingKeys = new Set(newOrdered.map((col) => col.key));
      const newColumns = columns
        .filter((col) => selectedColumns.includes(col.key) && !existingKeys.has(col.key))
        .sort((a, b) => a.titleText.localeCompare(b.titleText));
      setOrderedSelectedColumns([...newOrdered, ...newColumns]);
    }
  }, [selectedColumns, columns]);

  const handleSelectColumn = (col) => setSelectedColumns([...selectedColumns, col.key]);
  const handleRemoveColumn = (col) => setSelectedColumns(selectedColumns.filter((key) => key !== col.key));
  const handleSelectAll = () => setSelectedColumns(columns.map((col) => col.key));
  const handleDeselectAll = () => { setSelectedColumns([]); setOrderedSelectedColumns([]); };

  const handleMoveUp = (index) => {
    if (index > 0) {
      const newOrdered = [...orderedSelectedColumns];
      [newOrdered[index - 1], newOrdered[index]] = [newOrdered[index], newOrdered[index - 1]];
      setOrderedSelectedColumns(newOrdered);
      setSelectedColumns(newOrdered.map((col) => col.key));
    }
  };

  const handleMoveDown = (index) => {
    if (index < orderedSelectedColumns.length - 1) {
      const newOrdered = [...orderedSelectedColumns];
      [newOrdered[index], newOrdered[index + 1]] = [newOrdered[index + 1], newOrdered[index]];
      setOrderedSelectedColumns(newOrdered);
      setSelectedColumns(newOrdered.map((col) => col.key));
    }
  };

  const filteredAvailableColumns = availableColumns.filter((col) => col.titleText?.toLowerCase().includes(searchText.toLowerCase())
    || col.dataIndex?.toLowerCase().includes(searchText.toLowerCase()));

  return (
    <Modal
      title="Seleccionar y ordenar columnas para exportar"
      open={visible}
      onCancel={onCancel}
      width={1000}
      footer={[
        <Button key="cancel" onClick={onCancel}>Cancelar</Button>,
        <Button key="confirm" type="primary" onClick={onConfirm}>Exportar Excel</Button>,
      ]}
    >
      <Row gutter={16}>
        <Col span={12}>
          <div style={{
            marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          }}
          >
            <strong>
              Columnas disponibles (
              {availableColumns.length}
              )
            </strong>
            <Button size="small" onClick={handleSelectAll}>Seleccionar todas</Button>
          </div>
          <div style={{ marginBottom: 16 }}>
            <Input
              placeholder="Buscar columnas disponibles..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              allowClear
            />
          </div>
          <div style={{
            maxHeight: 400, overflowY: 'auto', border: '1px solid #f0f0f0', padding: 8, borderRadius: 4,
          }}
          >
            <List
              dataSource={filteredAvailableColumns}
              renderItem={(col) => (
                <List.Item style={{ cursor: 'pointer', padding: '8px' }} onClick={() => handleSelectColumn(col)} hoverable>
                  <Tooltip title={col.dataIndex}>
                    <strong>{col.titleText}</strong>
                    <br />
                    <small style={{ color: '#999' }}>{col.dataIndex}</small>
                  </Tooltip>
                </List.Item>
              )}
            />
            {filteredAvailableColumns.length === 0 && (
              <div style={{ textAlign: 'center', padding: 20, color: '#999' }}>No hay columnas disponibles</div>
            )}
          </div>
        </Col>
        <Col span={12}>
          <div style={{
            marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          }}
          >
            <strong>
              Columnas seleccionadas (
              {orderedSelectedColumns.length}
              )
            </strong>
            <Button size="small" danger onClick={handleDeselectAll}>Eliminar todas</Button>
          </div>
          <div style={{
            maxHeight: 400, overflowY: 'auto', border: '1px solid #f0f0f0', padding: 8, borderRadius: 4, backgroundColor: '#fafafa',
          }}
          >
            <List
              dataSource={orderedSelectedColumns}
              renderItem={(col, index) => (
                <List.Item
                  style={{
                    backgroundColor: 'white', marginBottom: 4, padding: '8px 12px', borderRadius: 4, border: '1px solid #e8e8e8',
                  }}
                  actions={[
                    <Button type="text" icon={<ArrowUpOutlined />} onClick={(e) => { e.stopPropagation(); handleMoveUp(index); }} disabled={index === 0} size="small" />,
                    <Button type="text" icon={<ArrowDownOutlined />} onClick={(e) => { e.stopPropagation(); handleMoveDown(index); }} disabled={index === orderedSelectedColumns.length - 1} size="small" />,
                    <Button type="text" danger onClick={(e) => { e.stopPropagation(); handleRemoveColumn(col); }} size="small">Eliminar</Button>,
                  ]}
                >
                  <div>
                    <strong>{col.titleText}</strong>
                    <br />
                    <small style={{ color: '#999' }}>{col.dataIndex}</small>
                  </div>
                </List.Item>
              )}
            />
            {orderedSelectedColumns.length === 0 && (
              <div style={{ textAlign: 'center', padding: 20, color: '#999' }}>Selecciona columnas de la izquierda</div>
            )}
          </div>
        </Col>
      </Row>
      <Divider />
      <div style={{ textAlign: 'right', color: '#666' }}>
        Total columnas:
        {' '}
        {columns.length}
        {' '}
        | Seleccionadas:
        {' '}
        {orderedSelectedColumns.length}
      </div>
    </Modal>
  );
};

const HonorariosAsimilados = ({ permission }) => {
  const [form] = Form.useForm();
  const [formFiliacion] = Form.useForm();
  const [formOperacionales] = Form.useForm();
  const [formDireccion] = Form.useForm();
  const [formPlazas] = Form.useForm();
  const [formPago] = Form.useForm();
  const [formAutorizar] = Form.useForm();

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [data, setData] = useState([]);
  const [fullData, setFullData] = useState([]);

  const [estadosEmpleado, setEstadosDeEmpleado] = useState([]);
  const [puestos, setPuestos] = useState([]);
  const [metodosDePagos, setMetodosDePagos] = useState([]);
  const [bancos, setBancos] = useState([]);
  const [tiposDeDepositos, setTiposDeDepositos] = useState([]);
  const [paises, setPaises] = useState([]);
  const [estados, setEstados] = useState([]);
  const [generos, setGeneros] = useState([]);
  const [tiemposDeContrataciones, setTiemposDeContrataciones] = useState([]);
  const [jornadas, setJornadas] = useState([]);
  const [tiposDeSueldos, setTiposDeSueldos] = useState([]);
  const [sindicatos, setSindicatos] = useState([]);
  const [periodicidadesDePagos, setPeriodicidadesDePagos] = useState([]);
  const [zonasDeSalariosMinimos, setZonasDeSalariosMinimos] = useState([]);
  const [tiposRegimenesNominas, setTiposRegimenesNominas] = useState([]);
  const [tiposDeIdentificaciones, setTiposDeIdentificaciones] = useState([]);
  const [tiposDeSeguridadesSociales, setTiposDeSeguridadesSociales] = useState([]);
  const [registrosPatronales, setRegistrosPatronales] = useState([]);
  const [nivelesDeEstudios, setNivelesDeEstudios] = useState([]);
  const [abreviaturasDeCarreras, setAbreviaturasDeCarreras] = useState([]);
  const [comprobantesDeEstudios, setComprobantesDeEstudios] = useState([]);
  const [especialidadesDeEstudios, setEspecialidadesDeEstudios] = useState([]);
  const [nacionalidades, setNacionalidades] = useState([]);
  const [estadoCivil, setEstadoCivil] = useState([]);
  const [motivosAlta, setMotivosAlta] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [coloniasCargadas, setColoniasCargadas] = useState([]);
  const [tiposDeFunciones, setTiposDeFunciones] = useState([]);
  const [tiposDeContrataciones, setTiposDeContrataciones] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [codigosPostales, setCodigosPostales] = useState([]);
  const [preferenciaPartidaria, setPreferenciaPartidaria] = useState([]);
  const [cuipHabilitado, setCuipHabilitado] = useState(false);
  const [tiposDeNominasEmpleados, setTiposDeNominasEmpleados] = useState([]);
  const [caracteresDeNombramiento, setCaracteresDeNombramiento] = useState([]);
  const [nombramientosSinPaginar, setNombramientosSinPaginar] = useState([]);
  const [tiposOrigenesContratacion, setTiposOrigenesContratacion] = useState([]);
  const [origenContratacionSeleccionado, setOrigenContratacionSeleccionado] = useState(null);
  const [tipoDeActividad, setTipoDeActividad] = useState([]);
  const [areas, setAreas] = useState([]);
  const [tiposEmpleados, setTiposEmpleados] = useState([]);

  const [currentTabKey, setCurrentTabKey] = useState('general');
  const [currentTabKeyDO, setCurrentTabKeyDO] = useState('adscripcion');
  const [currentParentTabKey, setCurrentParentTabKey] = useState('general');

  const [isBlocked, setIsBlocked] = useState(false);
  const [disableEstatus, setDisableEstatus] = useState(true);
  const [nominaDisplay, setNominaDisplay] = useState();
  const [honorarioAsimiladoId, setHonorarioAsimiladoId] = useState();
  const [honorarioAsimiladoEmpleadoAsociado, setHonorarioAsimiladoEmpleadoAsociado] = useState();
  const [datoOperacionalId, setDatoOperacionalId] = useState();
  const [nombreHonorarioAsimiladoEditar, setNombreHonorarioAsimiladoEditar] = useState('');
  const [apellidoPHonorarioAsimiladoEditar, setApellidoPHonorarioAsimiladoEditar] = useState('');
  const [apellidoMHonorarioAsimiladoEditar, setApellidoMHonorarioAsimiladoEditar] = useState('');
  const [numHonorarioAsimiladoEditar, setNumHonorarioAsimiladoEditar] = useState();

  const [loadingTime, setLoadingTime] = useState(0);
  // eslint-disable-next-line no-unused-vars
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });

  const [selectedRows, setSelectedRows] = useState([]);
  const [visibleAutorizar, setVisibleAutorizar] = useState(false);

  // Estados para selector de columnas Excel
  const [showColumnSelector, setShowColumnSelector] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [availableColumns, setAvailableColumns] = useState([]);

  const fetchData = async () => {
    setLoading(true);
    const _data = await getHonorarioAsimiladoVistaoptimizado();
    const ordenados = formatReceived(_data)
      .sort((a, b) => Number(a.numero_de_honorario_asimilado) - Number(b.numero_de_honorario_asimilado));
    setFullData(ordenados);
    setData(ordenados);
    setLoading(false);
  };

  const calcularEdad = (birthday) => {
    const ageDifMs = Date.now() - birthday;
    const ageDate = new Date(ageDifMs);
    const ageNum = (ageDate.getUTCFullYear() - 1970);
    if (Math.sign(ageNum) === -1) return 0;
    return ageNum;
  };

  const calcularAntiguedad = (fechaRegistro) => {
    const fechaDiferencia = Date.now() - fechaRegistro;
    const fechaNueva = new Date(fechaDiferencia);
    const fechaAnual = (fechaNueva.getUTCFullYear() - 1970);
    const fechaMes = (fechaNueva.getUTCMonth());
    if ((Math.sign(fechaAnual) === -1) || (Number.isNaN(fechaAnual))) return 0;
    return `${fechaAnual} ${(fechaAnual === 1 ? 'año' : 'años')} ${fechaMes} ${(fechaMes === 1 ? 'mes' : 'meses')}`;
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      const start = Date.now();
      setLoading(true);
      try {
        await checkToken();
        const [
          _tiposDeActividades,
          _estadosDeEmpleados,
          _paises,
          _estados,
          _generos,
          _estadosCiviles,
          _puestos,
          _metodosDePagos,
          _bancos,
          _tiposDeDepositos,
          _tiemposDeContrataciones,
          _jornadas,
          _tiposDeSueldos,
          _sindicatos,
          _periodicidadesDePagos,
          _zonasDeSalariosMinimos,
          _tiposRegimenesNominas,
          _tiposDeIdentificaciones,
          _tiposDeSeguridadesSociales,
          _tiposDeFunciones,
          _tiposDeContrataciones,
          _registrosPatronales,
          _nivelesDeEstudios,
          _abreviaturasDeCarreras,
          _comprobantesDeEstudios,
          _especialidadesDeEstudios,
          _nacionalidades,
          _data,
          _preferenciaPartidaria,
          _tiposOrigenesContratacion,
          _tiposDeNominasEmpleados,
          _caracteresDeNombramiento,
          _nombramientosSinPaginar,
          _areas,
          _tiposEmpleados,
          _motivosAlta,
        ] = await Promise.all([
          getTiposDeActividades(),
          getEstadosDeEmpleados(),
          getPaises(),
          getEstados(),
          getGeneros(),
          getEstadosCiviles(),
          getPuestos(),
          getMetodosDePagos(),
          getBancos(),
          getTiposDeDepositos(),
          getTiemposDeContrataciones(),
          getJornadas({ estados_globales: ESTATUS_AUTORIZADO }),
          getTiposDeSueldos(),
          getSindicatos({ estados_globales: ESTATUS_AUTORIZADO }),
          getPeriodicidadesDePagos({ estados_globales: ESTATUS_AUTORIZADO }),
          getZonasDeSalariosMinimos({ estados_globales: ESTATUS_AUTORIZADO }),
          getTiposRegimenesNominas(),
          getTiposDeIdentificaciones({ estados_globales: ESTATUS_AUTORIZADO }),
          getTiposDeSeguridadesSociales({ estados_globales: ESTATUS_AUTORIZADO }),
          getTiposDeFunciones({ estados_globales: ESTATUS_AUTORIZADO }),
          getTiposDeContrataciones({ estados_globales: ESTATUS_AUTORIZADO }),
          getRegistrosPatronales(),
          getNivelesDeEstudios({ estados_globales: ESTATUS_AUTORIZADO }),
          getAbreviaturasDeCarreras({ estados_globales: ESTATUS_AUTORIZADO }),
          getComprobantesDeEstudios({ estados_globales: ESTATUS_AUTORIZADO }),
          getEspecialidadesDeEstudios({ estados_globales: ESTATUS_AUTORIZADO }),
          getNacionalidades(),
          getHonorarioAsimiladoVistaoptimizado(),
          getPreferenciaSPartidarias(),
          getTiposDeOrigenesDeContratacion(),
          getTiposDeNominasEmpleados(),
          getCaracteresDeNombramiento(),
          getNombramientosSinPaginar(),
          getAreas({ estados_globales: ESTATUS_AUTORIZADO }),
          getTiposDeEmpleados(),
          getMotivosDeMovimientosDeEmpleados({ tipos_de_movimientos_de_empleados: TIPO_MOVIMIENTO_ALTA }),
        ]);

        if (mounted) {
          setTipoDeActividad(_tiposDeActividades);
          setEstadosDeEmpleado(_estadosDeEmpleados);
          setPaises(_paises);
          setEstados(_estados);
          setGeneros(_generos);
          setEstadoCivil(_estadosCiviles);
          setPuestos(_puestos);
          setMetodosDePagos(_metodosDePagos);
          setBancos(_bancos);
          setTiposDeDepositos(_tiposDeDepositos);
          setTiemposDeContrataciones(_tiemposDeContrataciones);
          setJornadas(_jornadas);
          setTiposDeSueldos(_tiposDeSueldos);
          setSindicatos(_sindicatos);
          setPeriodicidadesDePagos(_periodicidadesDePagos);
          setZonasDeSalariosMinimos(_zonasDeSalariosMinimos);
          setTiposRegimenesNominas(_tiposRegimenesNominas);
          setTiposDeIdentificaciones(_tiposDeIdentificaciones);
          setTiposDeSeguridadesSociales(_tiposDeSeguridadesSociales);
          setTiposDeFunciones(_tiposDeFunciones);
          setTiposDeContrataciones(_tiposDeContrataciones);
          setRegistrosPatronales(_registrosPatronales);
          setNivelesDeEstudios(_nivelesDeEstudios);
          setAbreviaturasDeCarreras(_abreviaturasDeCarreras);
          setComprobantesDeEstudios(_comprobantesDeEstudios);
          setEspecialidadesDeEstudios(_especialidadesDeEstudios);
          setNacionalidades(_nacionalidades);
          setPreferenciaPartidaria(_preferenciaPartidaria);
          setTiposOrigenesContratacion(_tiposOrigenesContratacion);
          setTiposDeNominasEmpleados(_tiposDeNominasEmpleados);
          setCaracteresDeNombramiento(_caracteresDeNombramiento);
          setNombramientosSinPaginar(_nombramientosSinPaginar);
          setAreas(_areas);
          setTiposEmpleados(_tiposEmpleados);
          setMotivosAlta(_motivosAlta);

          const honorariosAsimilados = formatReceived(_data)
            .sort((a, b) => Number(a.numero_de_honorario_asimilado) - Number(b.numero_de_honorario_asimilado));
          setFullData(honorariosAsimilados);
          setData(honorariosAsimilados);
          setPagination({ current: 1, pageSize: 10, total: honorariosAsimilados.length });
          setLoading(false);

          const end = Date.now();
          setLoadingTime(((end - start) / 1000).toFixed(2));
        }
      } catch (err) {
        setLoading(false);
        onError(err, setLoading);
      }
    };
    fetchAll();
    return () => { mounted = false; };
  }, []);

  const onCancelWithFetch = () => {
    fetchData();
    setSelectedRowKeys([]);
    setHonorarioAsimiladoId();
    setHonorarioAsimiladoEmpleadoAsociado();
    setCurrentTabKey('general');
    setCurrentTabKeyDO('adscripcion');
    setCurrentParentTabKey('general');
    setData([]);
    setVisible(false);
    setOrigenContratacionSeleccionado(null);
  };

  const onCancel = () => {
    setNombreHonorarioAsimiladoEditar('');
    setApellidoPHonorarioAsimiladoEditar('');
    setApellidoMHonorarioAsimiladoEditar('');
    setNumHonorarioAsimiladoEditar();
    setSelectedRowKeys([]);
    setVisible(false);

    form.resetFields();
    formFiliacion.resetFields();
    formOperacionales.resetFields();
    formDireccion.resetFields();
    formPlazas.resetFields();
    formPago.resetFields();

    setCurrentTabKey('general');
    setCurrentTabKeyDO('adscripcion');
    setCurrentParentTabKey('general');
    setHonorarioAsimiladoId();
    setHonorarioAsimiladoEmpleadoAsociado();
    setDatoOperacionalId();
    setNominaDisplay();
    setIsBlocked(false);
    setCuipHabilitado(false);
  };

  const onClickEdit = async (responseData = null) => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      const match = responseData || fullData.find((item) => item.id === key);
      const honorarioAsimiladoApi = await getHonorarioAsimilado(match.id);

      if (!honorarioAsimiladoApi) {
        message.error('No se encontró información del honorario asimilado.');
        setLoading(false);
        return;
      }

      if (honorarioAsimiladoApi.numero_de_honorario_asimilado) setNumHonorarioAsimiladoEditar(honorarioAsimiladoApi.numero_de_honorario_asimilado);
      if (honorarioAsimiladoApi.nombre) setNombreHonorarioAsimiladoEditar(honorarioAsimiladoApi.nombre);
      if (honorarioAsimiladoApi.apellido_paterno) setApellidoPHonorarioAsimiladoEditar(honorarioAsimiladoApi.apellido_paterno);
      if (honorarioAsimiladoApi.apellido_materno) setApellidoMHonorarioAsimiladoEditar(honorarioAsimiladoApi.apellido_materno);
      else setApellidoMHonorarioAsimiladoEditar('');

      setTimeout(() => {
        if (honorarioAsimiladoApi) {
          setHonorarioAsimiladoId(honorarioAsimiladoApi?.id);
          setHonorarioAsimiladoEmpleadoAsociado(honorarioAsimiladoApi?.empleado_asociado);
          form.resetFields();
          formOperacionales.resetFields();
          formDireccion.resetFields();
          formPlazas.resetFields();
          setOrigenContratacionSeleccionado(honorarioAsimiladoApi.tipo_de_origen_contratacion);

          setTimeout(async () => {
            const honorarioAsimilado = formatReceivedValues(honorarioAsimiladoApi);

            form.setFieldsValue(honorarioAsimilado);
            formFiliacion.setFieldsValue({
              RFC: honorarioAsimiladoApi.RFC || null,
              curp: honorarioAsimiladoApi.curp || null,
              tipo_de_identificacion: honorarioAsimiladoApi.tipo_de_identificacion ?? null,
              numero_de_identificacion: honorarioAsimiladoApi.numero_de_identificacion ?? null,
              tipo_de_seguridad_social: honorarioAsimiladoApi.tipo_de_seguridad_social ?? null,
              numero_de_seguridad_social: honorarioAsimiladoApi.numero_de_seguridad_social ?? null,
              registro_patronal: honorarioAsimiladoApi.registro_patronal ?? null,
              salario_base_cotizacion_imss: honorarioAsimiladoApi.salario_base_cotizacion_imss ?? null,
              preferencia_partidaria: honorarioAsimiladoApi.preferencia_partidaria ?? null,
              codigo_postal_fiscal_texto_libre: honorarioAsimiladoApi.codigo_postal_fiscal_texto_libre ?? null,
            });

            // Forzamos estatus siempre bloqueado
            setDisableEstatus(true);

            form.setFieldsValue({
              edad: calcularEdad(form.getFieldValue('fecha_de_nacimiento')),
            });

            const datoOpBec = await getDatoOperacionalesDeHonorariosAsimilados({ honorario_asimilado: honorarioAsimiladoApi.id });
            if (datoOpBec.length > 0) {
              setDatoOperacionalId(datoOpBec[0].id);
              formOperacionales.setFieldsValue(formatReceived(datoOpBec[0]));
              const fechaRegistro = datoOpBec[0]?.fecha_de_alta;
              if (fechaRegistro) {
                formOperacionales.setFieldsValue({ antiguedad: calcularAntiguedad(fechaRegistro) });
              }
              const tipoFuncionId = datoOpBec[0]?.tipo_de_funcion;
              if (tipoFuncionId) setCuipHabilitado(tipoFuncionId === 'Seguridad Pública');
            } else {
              setDatoOperacionalId();
              formOperacionales.resetFields();
            }

            const datoPagoBec = await getDatosDePagoDeHonorariosAsimilados({ honorario_asimilado: honorarioAsimiladoApi.id });
            if (datoPagoBec.length > 0) {
              formPago.setFieldsValue(formatReceived(datoPagoBec[0]));
            }

            setVisible(true);
          });
        }
      });
      setLoading(false);
    } catch (error) {
      onError(error, setLoading);
      setLoading(false);
    }
  };

  // Mapa de campo -> pestaña, usado para avisar y llevar al usuario al campo
  // requerido que falló la validación (antes fallaba en silencio).
  const requiredFormStructure = [
    {
      parentTabKey: 'general',
      tabKey: 'general',
      tabFields: ['numero_de_honorario_asimilado', 'nombre', 'apellido_paterno',
        'genero', 'nacionalidad', 'pais', 'fecha_de_nacimiento', 'estado_civil', 'tipo_sangre',
        'estado_del_honorario_asimilado'],
    },
    {
      parentTabKey: 'general',
      tabKey: 'filiacion',
      tabFields: ['tipo_de_identificacion', 'numero_de_identificacion', 'curp',
        'codigo_postal_fiscal_texto_libre'],
    },
    {
      parentTabKey: 'general',
      tabKey: 'contacto',
      tabFields: ['correo_electronico', 'contacto_de_emergencia'],
    },
    {
      parentTabKey: 'general',
      tabKey: 'otros',
      tabFields: ['fecha_de_aviso'],
    },
  ];

  const onValidationError = (err) => {
    if (!err?.errorFields) return false;
    const errorKeys = err.errorFields.map((e) => e.name[0]);
    const formWithErrors = requiredFormStructure.find(
      (obj) => obj.tabFields.some((val) => errorKeys.includes(val)),
    );
    if (formWithErrors) {
      setTimeout(() => {
        setCurrentParentTabKey(formWithErrors.parentTabKey);
        setCurrentTabKey(formWithErrors.tabKey);
      });
    }
    message.warn('Favor de corregir los errores señalados');
    return true;
  };

  const onFinish = async (_values, _continue = true) => {
    try {
      setLoading(true);
      await form.validateFields();
      await formFiliacion.validateFields();

      form.setFieldsValue({
        edad: calcularEdad(form.getFieldValue('fecha_de_nacimiento')),
      });

      const values = {
        ...form.getFieldsValue(),
        ...formFiliacion.getFieldsValue(),
        ...formOperacionales.getFieldsValue(),
        ...formPlazas.getFieldsValue(),
      };

      if (!values.estado_del_honorario_asimilado) {
        values.estado_del_honorario_asimilado = 1;
      }

      const [honorarioAsimiladoObj] = selectedRowKeys;

      // Al crear, "fecha_de_alta"/"motivo_alta" también existen como campos de
      // formOperacionales (Adscripción, deshabilitada hasta el primer guardado), cuyo
      // valor undefined pisaría al de este paso por el orden del merge de arriba.
      if (!honorarioAsimiladoObj) {
        values.fecha_de_alta = form.getFieldValue('fecha_de_alta_inicial');
        values.motivo_alta = form.getFieldValue('motivo_alta_inicial');
      }
      delete values.fecha_de_alta_inicial;
      delete values.motivo_alta_inicial;

      const saved = await (honorarioAsimiladoObj ? patchHonorarioAsimilado(honorarioAsimiladoObj, values) : postHonorarioAsimilado(values));

      if (saved) {
        // Sindicalizado, sindicato, fechas/motivos de alta-baja, CUIP y área de comisión
        // viven en el registro de Datos Operacionales, no en el Honorario Asimilado.
        let datoOperacionalOk = true;
        if (datoOperacionalId) {
          const datoOperacionalGuardado = await patchDatoOperacionalDelHonorarioAsimilado(datoOperacionalId, {
            sindicalizado: values.sindicalizado,
            sindicato: values.sindicato,
            fecha_de_alta_en_gobierno: values.fecha_de_alta_en_gobierno,
            fecha_de_alta: values.fecha_de_alta,
            motivo_alta: values.motivo_alta,
            fecha_de_baja: values.fecha_de_baja,
            motivo_baja: values.motivo_baja,
            cuip: values.cuip,
            directorio_de_area_comision: values.directorio_de_area_comision,
          });
          datoOperacionalOk = Boolean(datoOperacionalGuardado);
        } else if (values.sindicalizado || values.sindicato || values.cuip
          || values.motivo_alta || values.motivo_baja
          || values.fecha_de_alta_en_gobierno || values.fecha_de_baja
          || values.directorio_de_area_comision) {
          message.warning('Sindicalizado, Sindicato y demás campos de Datos Operacionales no se guardaron: este Honorario Asimilado aún no tiene una plaza asignada. Asígnala primero desde Administración de Plazas.');
        }

        if (datoOperacionalOk) {
          onSuccess({}, `${selectedRowKeys.length ? 'Editado' : 'Agregado'} exitosamente.`);
        }
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          await onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      if (!onValidationError(err)) {
        onError(err, setLoading);
      }
      setLoading(false);
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteHonorarioAsimilado(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);

    const estaAutorizado = record.estado_del_honorario_asimilado === 4
      || record.estados_globales === 4
      || record.estado_del_honorario_asimilado === ESTATUS_AUTORIZADO
      || record.estados_globales === ESTATUS_AUTORIZADO;

    setIsBlocked(estaAutorizado);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    onCancel();
    setCurrentParentTabKey('general');
    setCurrentTabKey('general');
    setVisible(true);
  };

  const onClickDelete = () => setVisibleAlert(true);

  const seguimiento = useSeguimientoDeRegistro({
    contentTypeAppLabel: 'entidad',
    contentTypeModel: 'honorarioasimilado',
    moduloDescripcion: 'Nómina',
    documentoOperativoDescripcion: 'Honorarios Asimilados',
    moduloOrigenLabel: 'Honorarios Asimilados',
    registros: fullData,
    seleccionIds: selectedRowKeys,
    registroActivo: open ? fullData.find((e) => e.id === selectedRowKeys[0]) || null : null,
    mutable: true,
    getRegistroLabel: (row) => `Honorario Asimilado ${row.numero_de_honorario_asimilado || row.id}`,
  });

  const columns = [
    {
      titleText: 'ID', dataIndex: 'id', key: 'id', width: 80,
    },
    {
      titleText: 'Número de Honorario Asimilado', dataIndex: 'numero_de_honorario_asimilado', key: 'numero_de_honorario_asimilado', width: 200,
    },
    {
      titleText: 'Nombre', dataIndex: 'nombre', key: 'nombre', width: 250,
    },
    {
      titleText: 'Apellido Paterno', dataIndex: 'apellido_paterno', key: 'apellido_paterno', width: 250,
    },
    {
      titleText: 'Apellido Materno', dataIndex: 'apellido_materno', key: 'apellido_materno', width: 250,
    },
    {
      titleText: 'Puesto', dataIndex: 'puesto_clave_y_descripcion', key: 'puesto_clave_y_descripcion', width: 200,
    },
    {
      titleText: 'Área', dataIndex: 'directorio_area_clave_y_nombre', key: 'directorio_area_clave_y_nombre', width: 250,
    },
    {
      titleText: 'No. de Plaza', dataIndex: 'plaza_clave_y_descripcion', key: 'plaza_clave_y_descripcion', width: 200,
    },
    {
      titleText: 'Tipo de Nómina', dataIndex: 'tipo_nomina_empleado', key: 'tipo_nomina_empleado', width: 250,
    },
    {
      titleText: 'Estatus', dataIndex: 'estado_del_honorario_asimilado', key: 'estado_del_honorario_asimilado', width: 200,
    },
    {
      titleText: 'Sueldo Diario',
      dataIndex: 'sueldo_diario',
      key: 'sueldo_diario',
      width: 150,
      render: (val) => (val ? currencyFormatter(val) : '-'),
    },
    {
      titleText: 'Sueldo Mensual',
      dataIndex: 'sueldo_mensual',
      key: 'sueldo_mensual',
      width: 180,
      render: (val) => (val ? currencyFormatter(val) : '-'),
    },
  ];

  const getAllAvailableColumns = () => {
    if (fullData.length === 0) return [];
    const allKeysSet = new Set();
    fullData.forEach((record) => Object.keys(record).forEach((key) => allKeysSet.add(key)));
    const allKeys = Array.from(allKeysSet).sort();
    return allKeys.map((key) => ({
      key,
      dataIndex: key,
      titleText: key.split('_').map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(' '),
    }));
  };

  const onClickExportarExcel = async () => {
    try {
      const allColumns = getAllAvailableColumns();
      setAvailableColumns(allColumns);
      setSelectedColumns([]);
      setShowColumnSelector(true);
    } catch (err) {
      message.error('Error al preparar el selector de columnas');
    }
  };

  const handleExportWithSelectedColumns = async () => {
    try {
      setShowColumnSelector(false);
      setLoading(true);

      if (selectedColumns.length === 0) {
        message.warning('Debes seleccionar al menos una columna para exportar');
        setLoading(false);
        return;
      }

      const selectedColDefs = availableColumns
        .filter((col) => selectedColumns.includes(col.key))
        .sort((a, b) => selectedColumns.indexOf(a.key) - selectedColumns.indexOf(b.key));

      const excelData = fullData.map((record) => {
        const rowData = {};
        selectedColDefs.forEach((col) => {
          const key = col.dataIndex;
          let value = record[key];
          if (key.includes('fecha') && value) value = moment(value).format('DD/MM/YYYY');
          else if (key === 'eliminado') value = value ? 'Sí' : 'No';
          else if (key === 'sueldo_diario' || key === 'sueldo_mensual') value = value ? currencyFormatter(value) : '';
          rowData[col.titleText || key] = value;
        });
        return rowData;
      });

      const worksheet = XLSX.utils.json_to_sheet(excelData);
      worksheet['!views'] = [{ state: 'frozen', xSplit: 0, ySplit: 1 }];
      const colWidths = Object.keys(excelData[0] || {}).map((key) => ({
        wch: Math.max(key.length, ...excelData.map((row) => String(row[key] || '').length)) + 2,
      }));
      worksheet['!cols'] = colWidths;

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Honorarios Asimilados');
      const fecha = moment().format('YYYY-MM-DD');
      XLSX.writeFile(workbook, `HonorariosAsimilados_ColumnasSeleccionadas_${fecha}.xlsx`);

      setLoading(false);
      message.success(`Exportados ${excelData.length} honorarios asimilados con ${selectedColumns.length} columnas`);
    } catch (err) {
      message.error('Error al generar el Excel.');
      setLoading(false);
    }
  };

  const menuExportar = (
    <Menu
      items={[
        {
          key: 1,
          label: 'Excel',
          icon: <FileExcelOutlined />,
          onClick: () => onClickExportarExcel(),
        },
        {
          key: 2,
          label: 'PDF',
          icon: <FilePdfOutlined />,
        },
      ]}
    />
  );

  const requiredRule = { required: true, message: 'El campo es requerido' };

  const validadorSoloLetras = async (rule, value) => {
    const isValid = /^[a-zA-ZñÑáÁéÉíÍóÓúÚ]+(?: [a-zA-ZñÑáÁéÉíÍóÓúÚ]+)*$/.test(value);
    if (!isValid && value.length > 0) throw new Error('Ingrese solo letras');
  };

  const rules = {
    required: [requiredRule],
    lada: [requiredRule],
    numero_de_telefono: [requiredRule],
    clave: [requiredRule, { pattern: SLUG_PATTERN, message: 'Ingrese un número de honorario asimilado válido' }],
    RFC: [requiredRule, { pattern: RFC_PATTERN, message: 'Ingrese un RFC válido' }],
    curp: [
      requiredRule,
      {
        validator: async (rule, value) => {
          if (value) {
            const validado = value.toUpperCase().match(CURP_PATTERN);
            if (!validado || validado[2] !== digitoVerificador(validado[1])) throw new Error('Ingrese una CURP válida');
          }
        },
      },
    ],
    fecha_de_nacimiento: [
      requiredRule,
      {
        validator: async (rule, value) => {
          if (!value) return;
          const fecha = typeof value.toDate === 'function' ? value.toDate() : new Date(value);
          const diff = Date.now() - fecha.getTime();
          const ageDate = new Date(diff);
          const ageNum = ageDate.getUTCFullYear() - 1970;
          if (diff < 0) throw new Error('Introduzca una fecha válida');
          else if (ageNum < 16) throw new Error('No se permiten honorarios asimilados menores de 16 años');
          else if (ageNum > 100) throw new Error('No se permiten honorarios asimilados mayores de 100 años');
        },
      },
    ],
    solo_numeros_enteros: [
      {
        validator: async (rule, value) => {
          if (value) {
            const ok = (/^\d+$/.test(value));
            if (!ok && value.length > 0) throw new Error('Ingrese un número válido');
          }
        },
      },
    ],
    sueldo_diario: [
      requiredRule,
      {
        validator: async (rule, value) => {
          if (value && !/^\d+(\.\d{1,2})?$/.test(value)) throw new Error('Ingrese un número válido con máximo dos decimales');
        },
      },
    ],
    telefono: [
      {
        validator: async (rule, value) => {
          if (value) {
            const ok = /^\d+$/.test(value);
            if (!ok || value.length !== 10) throw new Error('Ingrese un número válido de 10 dígitos');
          }
        },
      },
    ],
    no_identificacion: [
      requiredRule,
      {
        validator: async (rule, value) => {
          if (value) {
            const ok = /^\d+$/.test(value);
            if (!ok || value.length !== 11) throw new Error('Ingrese un número válido de 11 dígitos');
          }
        },
      },
    ],
    no_cedula_profesional: [
      {
        validator: async (rule, value) => {
          if (value) {
            const ok = /^\d+$/.test(value);
            if (!ok || value.length > 10) throw new Error('Ingrese un número válido menor a 10 dígitos');
          }
        },
      },
    ],
    correo_electronico: [requiredRule, { type: 'email', message: 'Ingrese un correo válido' }],
    entero_requerido: [
      requiredRule,
      {
        validator: async (rule, value) => {
          const isInteger = /^\d+$/.test(value);
          if (!isInteger && value?.length > 0) throw new Error('Ingrese un número válido');
        },
      },
    ],
    numero_de_seguridad_social: [
      {
        validator: async (rule, value) => {
          const isValid = /^\d{11}$/.test(value);
          if (!isValid) throw new Error('Ingrese un número de 11 dígitos');
        },
      },
    ],
    solo_letras_requerido: [requiredRule, { validator: validadorSoloLetras }],
    solo_letras: [{ validator: validadorSoloLetras }],
    nombre: [requiredRule, { pattern: NOMBRES_PATTERN_GENERICO, message: 'Ingrese un nombre válido' }],
    numero_tarjeta: [
      {
        validator: async (rule, value) => {
          const soloNumeros = /^\d+$/.test(value);
          const longitud = value?.length;
          if (!value || longitud < 1) return;
          if (!soloNumeros) throw new Error('Solo se permiten números.');
          if (longitud < 8 || longitud > 16) throw new Error('El valor debe ser entre 8 y 16 dígitos.');
        },
      },
    ],
    CLABE: [
      {
        validator: async (rule, value) => {
          const ok = (/^\d+$/.test(value));
          if (value?.length < 1 || !value) return;
          if (!ok) throw new Error('Solo se permiten números.');
          if (value?.length !== 18) throw new Error('El valor debe ser de 18 dígitos.');
        },
      },
    ],
  };

  const onAutorizarHonorariosAsimilados = async () => {
    try {
      const values = await formAutorizar.validateFields();
      setLoading(true);
      const fechaAltaStr = values.fecha_de_alta.format('YYYY-MM-DD');
      const payload = selectedRows.map((item) => ({ id: item.id, fecha_de_alta: fechaAltaStr }));
      await putAutorizarContratacionHonorarioAsimilado(payload);
      message.success('Autorizaciones realizadas con éxito');
      setVisibleAutorizar(false);
      setSelectedRows([]);
      setSelectedRowKeys([]);
      formAutorizar.resetFields();
      fetchData();
    } catch (err) {
      if (!err.errorFields) {
        message.error('Error al autorizar los honorarios asimilados');
      }
    } finally {
      setLoading(false);
    }
  };

  const getControls = () => {
    if (isBlocked) {
      return {
        onClickAdd,
        onClickEdit: () => onClickEdit(),
        onClickDelete: () => message.warning(`El honorario asimilado ${nominaDisplay || ''} se encuentra bloqueado`),
        onClickReload: fetchData,
      };
    }
    return {
      onClickAdd,
      onClickEdit: () => onClickEdit(),
      onClickDelete,
      onClickReload: fetchData,
    };
  };

  return (
    <Row className="container">
      {loading && (
        <div style={{ paddingBottom: 8 }}>⏳ Cargando...</div>
      )}
      {!loading && loadingTime > 0 && (
        <div style={{ marginBottom: 8 }}>
          ✅ Datos cargados en
          {' '}
          {loadingTime}
          {' '}
          segundos | Registros:
          {' '}
          {fullData.length}
        </div>
      )}
      <Spin tip="Cargando..." spinning={loading}>
        {!open ? (
          <>
            {seguimiento.conBarra(<Table
              data={fullData}
              pagination
              cols={[seguimiento.columnaSeguimiento, ...columns]}
              allowImport
              allowExtraImport
              allowExtraImportPago
              baseURI={baseURI}
              baseURIExtra={baseURIExtra}
              labelExtraImport="Datos Operativos"
              baseURIExtraPago={baseURIExtraPago}
              labelExtraImportPago="Datos Pago"
              rowSelection={rowSelection}
              handleOnRowClick={handleOnRowClick}
              controls={getControls()}
              permission={permission}
              customExportMenu={menuExportar}
              allowCustomExport
              customActions={[
                seguimiento.accionSeguimiento,
                {
                  text: `Autorización (${selectedRows.length})`,
                  className: 'primary',
                  icon: <CheckCircleOutlined />,
                  disabled: selectedRows.length === 0,
                  onClick: () => setVisibleAutorizar(true),
                },
              ]}
            />)}
            <ModalSelectorColumnas
              visible={showColumnSelector}
              onCancel={() => setShowColumnSelector(false)}
              onConfirm={handleExportWithSelectedColumns}
              columns={availableColumns}
              selectedColumns={selectedColumns}
              setSelectedColumns={setSelectedColumns}
            />
          </>
        ) : (
          <Card
            className="form-container"
            title={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Honorario Asimilado ${selectedRowKeys.length ? `"${numHonorarioAsimiladoEditar} - ${nombreHonorarioAsimiladoEditar} ${apellidoPHonorarioAsimiladoEditar}${apellidoMHonorarioAsimiladoEditar ? ` ${apellidoMHonorarioAsimiladoEditar}` : ''}"` : ''}`}
            extra={(
              <FormSubmitControls
                onFinish={onFinish}
                onCancel={onCancelWithFetch}
                loading={loading}
                onFinishText="Guardar y Continuar"
              />
            )}
            bordered={false}
          >
            {seguimiento.envolverConSeguimiento(
              <Tabs
                type="card"
                activeKey={currentParentTabKey || 'general'}
                onChange={setCurrentParentTabKey}
              >
                <TabPane
                  tab={(
                    <span>
                      <InfoCircleOutlined />
                      {' '}
                      Datos Generales
                    </span>
)}
                  key="general"
                  forceRender
                >
                  <div>
                    <Tabs activeKey={currentTabKey || 'general'} onChange={setCurrentTabKey} type="card">
                      <TabPane
                        tab={(
                          <span>
                            <InfoCircleOutlined />
                            {' '}
                            General
                          </span>
)}
                        key="general"
                        forceRender
                      >
                        <HonorarioAsimiladoGeneral
                          form={form}
                          formFiliacion={formFiliacion}
                          rules={rules}
                          selectedRowKeys={selectedRowKeys}
                          paises={paises}
                          estados={estados}
                          generos={generos}
                          estadoCivil={estadoCivil}
                          estadosEmpleado={estadosEmpleado}
                          nacionalidades={nacionalidades}
                          motivosAlta={motivosAlta}
                          calcularEdad={calcularEdad}
                          disableEstatus={disableEstatus}
                          isBlocked={isBlocked}
                        />
                      </TabPane>
                      <TabPane
                        tab={(
                          <span>
                            <FileTextOutlined />
                            {' '}
                            Filiación
                          </span>
)}
                        key="filiacion"
                        forceRender
                      >
                        <HonorarioAsimiladoFiliacion
                          form={form}
                          formFiliacion={formFiliacion}
                          tiposDeIdentificaciones={tiposDeIdentificaciones}
                          tiposDeSeguridadesSociales={tiposDeSeguridadesSociales}
                          registrosPatronales={registrosPatronales}
                          rules={rules}
                          codigosPostales={codigosPostales}
                          coloniasCargadas={coloniasCargadas}
                          preferenciaPartidaria={preferenciaPartidaria}
                          isBlocked={isBlocked}
                        />
                      </TabPane>
                      <TabPane
                        tab={(
                          <span>
                            <EnvironmentOutlined />
                            {' '}
                            Dirección
                          </span>
)}
                        key="direccion"
                        forceRender
                        disabled={!selectedRowKeys.length}
                      >
                        <HonorarioAsimiladoDireccion
                          formDireccion={formDireccion}
                          rules={rules}
                          coloniasCargadas={coloniasCargadas}
                          paises={paises}
                          isBlocked={isBlocked}
                          permission={permission}
                          honorarioAsimiladoId={honorarioAsimiladoId}
                        />
                      </TabPane>
                      <TabPane
                        tab={(
                          <span>
                            <FileTextOutlined />
                            {' '}
                            Estudios
                          </span>
)}
                        key="estudios"
                        forceRender
                      >
                        <HonorarioAsimiladoEstudios
                          form={form}
                          rules={rules}
                          nivelesDeEstudios={nivelesDeEstudios}
                          abreviaturasDeCarreras={abreviaturasDeCarreras}
                          comprobantesDeEstudios={comprobantesDeEstudios}
                          especialidadesDeEstudios={especialidadesDeEstudios}
                          isBlocked={isBlocked}
                        />
                      </TabPane>
                      <TabPane
                        tab={(
                          <span>
                            <PhoneOutlined />
                            {' '}
                            Contacto
                          </span>
)}
                        key="contacto"
                        forceRender
                      >
                        <HonorarioAsimiladoContacto
                          form={form}
                          rules={rules}
                          isBlocked={isBlocked}
                        />
                      </TabPane>
                      <TabPane
                        tab={<span>Otros</span>}
                        key="otros"
                        forceRender
                        disabled={!selectedRowKeys.length || !honorarioAsimiladoEmpleadoAsociado}
                      >
                        <OtrosHonorariosAsimilados
                          form={form}
                          rules={rules}
                          empleado_id={honorarioAsimiladoEmpleadoAsociado}
                          isBlocked={isBlocked}
                        />
                      </TabPane>
                    </Tabs>
                  </div>
                </TabPane>

                <TabPane
                  tab={(
                    <span>
                      <UserOutlined />
                      {' '}
                      Datos Operacionales
                    </span>
)}
                  key="operativos"
                  forceRender
                  disabled={!selectedRowKeys.length}
                >
                  <div>
                    <Tabs activeKey={currentTabKeyDO || 'adscripcion'} onChange={setCurrentTabKeyDO} type="card">
                      <TabPane
                        tab={(
                          <span>
                            <CalendarOutlined />
                            {' '}
                            Adscripción
                          </span>
)}
                        key="adscripcion"
                        forceRender
                      >
                        <HonorarioAsimiladoAdscripcion
                          form={formOperacionales}
                          rules={rules}
                          puestos={puestos}
                          formPlazas={formPlazas}
                          areas={areas}
                          tiposDeFunciones={tiposDeFunciones}
                          calcularAntiguedad={calcularAntiguedad}
                          setFechaDeAlta={() => {}}
                          setFechaDeBaja={() => {}}
                          setFechaDeReingreso={() => {}}
                          isBlocked={isBlocked}
                          cuipHabilitado={cuipHabilitado}
                          setCuipHabilitado={setCuipHabilitado}
                          honorarioAsimilado={honorarioAsimiladoId}
                          nombramientosSinPaginar={nombramientosSinPaginar}
                          plazaHonorarioAsimilado={{}}
                        />
                      </TabPane>
                      <TabPane
                        tab={(
                          <span>
                            <FileTextOutlined />
                            {' '}
                            Atributos
                          </span>
)}
                        key="atributos"
                        forceRender
                      >
                        <HonorarioAsimiladoAtributos
                          form={formOperacionales}
                          tipodeActividades={tipoDeActividad}
                          tiemposDeContrataciones={tiemposDeContrataciones}
                          tiposDeContrataciones={tiposDeContrataciones}
                          jornadas={jornadas}
                          tiposDeSueldos={tiposDeSueldos}
                          sindicatos={sindicatos}
                          perioricidadesDePago={periodicidadesDePagos}
                          zonasDeSalariosMinimos={zonasDeSalariosMinimos}
                          tiposRegimenesNominas={tiposRegimenesNominas}
                          tiposDeNominasEmpleados={tiposDeNominasEmpleados}
                          tiposEmpleados={tiposEmpleados}
                          rules={rules}
                          isBlocked={isBlocked}
                          caracteresDeNombramiento={caracteresDeNombramiento}
                          empleado={honorarioAsimiladoId}
                          nombramientosSinPaginar={nombramientosSinPaginar}
                          plazaEmpleado={{}}
                          tiposOrigenesContratacion={tiposOrigenesContratacion}
                          origenContratacionSeleccionado={origenContratacionSeleccionado}
                        />
                      </TabPane>
                    </Tabs>
                  </div>
                </TabPane>

                <TabPane
                  tab={(
                    <span>
                      <CreditCardOutlined />
                      {' '}
                      Formas de pago
                    </span>
)}
                  key="pago"
                  forceRender
                  disabled={!selectedRowKeys.length}
                >
                  <HonorarioAsimiladoFormaPago
                    form={formPago}
                    permission={permission}
                    empleado_id={honorarioAsimiladoId}
                    rules={rules}
                    metodosDePagos={metodosDePagos}
                    bancos={bancos}
                    tiposDeDepositos={tiposDeDepositos}
                  />
                </TabPane>

                <TabPane
                  tab={(
                    <span>
                      <SolutionOutlined />
                      {' '}
                      Documentos
                    </span>
)}
                  key="documentos"
                  forceRender
                  disabled={!selectedRowKeys.length}
                >
                  <DocumentosHonorariosAsimilados
                    permission={permission}
                    honorarioAsimiladoId={honorarioAsimiladoId}
                    formEmpleado={form}
                    rules={rules}
                    isBlocked={isBlocked}
                    actualizarTablaHonorariosAsimilados={fetchData}
                  />
                </TabPane>
              </Tabs>,
              'este Honorario Asimilado',
            )}
          </Card>
        )}

        {seguimiento.modalSeguimiento}
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Honorario Asimilado ${form.getFieldValue('nombre')} ${form.getFieldValue('apellido_paterno')}`}
          loading={loading}
        />

        {/* MODAL: AUTORIZAR */}
        <Modal
          open={visibleAutorizar}
          centered
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          width="45%"
          title={(
            <FormSubmitControls
              label="Confirmar Autorización"
              onFinish={onAutorizarHonorariosAsimilados}
              onCancel={() => { setVisibleAutorizar(false); formAutorizar.resetFields(); }}
              loading={loading}
              allowSave
            />
          )}
          onCancel={() => { setVisibleAutorizar(false); formAutorizar.resetFields(); }}
          forceRender
        >
          <Form form={formAutorizar} layout="vertical">
            <p style={{ fontSize: 16, marginTop: 10, marginBottom: 20 }}>
              ¿Deseas autorizar
              {' '}
              <strong>{selectedRows.length}</strong>
              {' '}
              honorario(s) asimilado(s)?
            </p>
            <Row>
              <Col xs={24} md={12}>
                <Form.Item
                  name="fecha_de_alta"
                  label="Fecha de Alta"
                  rules={[{ required: true, message: 'La fecha de alta es requerida' }]}
                >
                  <DatePicker style={{ width: '100%' }} format="DD/MM/YYYY" placeholder="Seleccionar fecha" />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </Spin>
    </Row>
  );
};

export default HonorariosAsimilados;
